"use client"

import { LogOut, UserCheck } from "lucide-react"
import { useEffect, useState } from "react"
import { getImpersonationTarget, stopImpersonation, type ImpersonationTarget } from "../lib/auth/impersonation"
import { Button } from "./ui/button"

/** Bandeau permanent pendant « se connecter en tant que » : qui, jusqu'à quand, et retour au compte superadmin. */
export function ImpersonationBanner() {
  const [target, setTarget] = useState<ImpersonationTarget | null>(null)

  useEffect(() => {
    setTarget(getImpersonationTarget())
  }, [])

  if (!target) return null
  const name = [target.prenom, target.nom].filter(Boolean).join(" ") || target.email || `#${target.id}`
  const expiresAt = new Date(target.expiresAt).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })

  return (
    <div role="status" className="flex flex-wrap items-center gap-3 border-b border-destructive/30 bg-destructive px-4 py-2 text-sm text-destructive-foreground">
      <UserCheck className="h-4 w-4 shrink-0" />
      <span className="flex-1 min-w-0">
        Vous êtes connecté en tant que <strong>{name}</strong>
        {target.email && name !== target.email ? ` (${target.email})` : ""} — accès en lecture et travail courant, jusqu'à{" "}
        {expiresAt}. Mot de passe, résiliation et paiement sont bloqués.
      </span>
      <Button size="sm" variant="secondary" onClick={() => stopImpersonation()}>
        <LogOut className="mr-2 h-4 w-4" /> Revenir à mon compte
      </Button>
    </div>
  )
}
